import { AfterViewInit, Component, ElementRef, Inject, Injector, OnDestroy, PLATFORM_ID, ViewChild } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { RouterLink } from '@angular/router';
import { runAfterHydration } from '../shared/run-after-hydration';
import { initPageScrollReveal } from '../shared/scroll-reveal.util';

@Component({
  selector: 'app-privacy-policy',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './privacy-policy.component.html',
  styleUrl: './privacy-policy.component.scss'
})
export class PrivacyPolicyComponent implements AfterViewInit, OnDestroy {
  @ViewChild('legalRoot') legalRoot!: ElementRef<HTMLElement>;

  private cleanups: Array<() => void> = [];

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private injector: Injector
  ) {}

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      runAfterHydration(this.injector, () => void this.setupScrollRevealAnimation());
    }
  }

  ngOnDestroy(): void {
    this.cleanups.forEach((cleanup) => cleanup());
    this.cleanups = [];
  }

  private async setupScrollRevealAnimation(): Promise<void> {
    const root = this.legalRoot?.nativeElement;
    if (!root) return;
    await initPageScrollReveal(root, this.cleanups);
  }
}
